/* eslint-disable */
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import styles from './Forms.css'
import TextInput from '../../containers/Forms/components/TextInput'
import TextAreaInput from '../../containers/Forms/components/TextAreaInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import {
  emailMask,
  phoneNumberMask,
  getDateOfBirthMask,
  requiredValidation,
  dateValidation,
  emailValidation,
  phoneValidation,
  minLen1Validation,
  notesLenValidation,
  notJustSpacesValidation,
  validateZipCode,
  ssnValidation,
  ssnMask,
} from '../../containers/Forms/components/formValidations'
import { getName } from '../../containers/Utilities'
import { UNASSIGNED_ORDERING_PHYSICIAN_OPTION, FORM_SEX_OPTIONS, getDateOfBirthFormat, US_STATES } from '../../constants'
import EditIcon from 'static/images/icons/pencil-outline.svg'
import SaveIcon from 'static/images/icons/content-save.svg'
import Loading from '../../components/Loading'
import { filterIsPhysicianPermission } from '../../store/appReducer'

class EditPatientForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: {
        firstName: true,
        lastName: true,
        middleName: true,
        customParticipantID: true,
        sex: true,
        email: true,
        socialSecurityNumber: true,
        dob: true,
        orderingPhysician: true,
        phone: true,
        notes: true,
        alternatePhone: true,
        emergencyContactName: true,
        emergencyContactPhone: true,
        patientAddressLine1: true,
        patientAddressLine2: true,
        patientCity: true,
        patientState: true,
        patientZip: true,
        shippingAddressLine1: true,
        shippingAddressLine2: true,
        shippingCity: true,
        shippingState: true,
        shippingZip: true,
        primaryInsuranceType: true,
        primaryMedicareId: true,
        primaryInsuranceCompanyName: true,
        primaryInsuranceGroup: true,
        primaryInsuranceAuthorizationNumber: true,
        primaryPolicyHolderName: true,
        primaryPolicyHolderRelationship: true,
        primarySubscriberId: true,
        secondaryInsuranceType: true,
        secondaryMedicareId: true,
        secondaryInsuranceCompanyName: true,
        secondaryInsuranceGroup: true,
        secondaryInsuranceAuthorizationNumber: true,
        secondaryPolicyHolderName: true,
        secondaryPolicyHolderRelationship: true,
        secondarySubscriberId: true,
      },
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucceeded !== this.props.submitSucceeded && nextProps.submitSucceeded === true) {
      this.setState({
        disabled: {
          firstName: true,
          lastName: true,
          middleName: true,
          customParticipantID: true,
          sex: true,
          email: true,
          dob: true,
          socialSecurityNumber: true,
          orderingPhysician: true,
          phone: true,
          notes: true,
          alternatePhone: true,
          emergencyContactName: true,
          emergencyContactPhone: true,
          patientAddressLine1: true,
          patientAddressLine2: true,
          patientCity: true,
          patientState: true,
          patientZip: true,
          shippingAddressLine1: true,
          shippingAddressLine2: true,
          shippingCity: true,
          shippingState: true,
          shippingZip: true,
          primaryInsuranceType: true,
          primaryMedicareId: true,
          primaryInsuranceCompanyName: true,
          primaryInsuranceGroup: true,
          primaryInsuranceAuthorizationNumber: true,
          primaryPolicyHolderName: true,
          primaryPolicyHolderRelationship: true,
          primarySubscriberId: true,
          secondaryInsuranceType: true,
          secondaryMedicareId: true,
          secondaryInsuranceCompanyName: true,
          secondaryInsuranceGroup: true,
          secondaryInsuranceAuthorizationNumber: true,
          secondaryPolicyHolderName: true,
          secondaryPolicyHolderRelationship: true,
          secondarySubscriberId: true,
        },
      })
    }
  }
  toggleDisable = field => {
    this.setState(prevState => ({
      disabled: Object.assign(prevState.disabled, {
        [field]: !prevState.disabled[field],
      }),
    }))
  }
  render() {
    const {
      handleSubmit,
      physicians,
      invalid,
      pristine,
      submitting,
      isSubmitting,
      initialValues: {
        customParticipantID,
        socialSecurityNumber,
      },
      idtfPatientFormData,
      me,
    } = this.props


    const {
      disabled,
    } = this.state

    let physicianOptions = [UNASSIGNED_ORDERING_PHYSICIAN_OPTION]

    if (physicians && physicians.data) {
      physicianOptions = [
        ...physicianOptions,
        ...filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id])),
      ]
    }

    const getEditClassName = field => (disabled[field] ? 'editIcon' : 'editIconActive')

    const PRIMARY_INSURANCE_TYPE_OPTIONS = [
      { value: 'self_pay', label: 'Self pay' },
      { value: 'medicare', label: 'Medicare' },
      { value: 'commercial_insurance', label: 'Commercial Insurance' }
    ];

    const SECONDARY_INSURANCE_TYPE_OPTIONS = [
      { value: 'medicare', label: 'Medicare' },
      { value: 'commercial_insurance', label: 'Commercial Insurance' },
      { value: 'none', label: 'None' },
    ];

    const POLICY_HOLDER_RELATIONSHIP_OPTIONS = [
      { value: 'self', label: 'Self' },
      { value: 'parent', label: 'Parent' },
      { value: 'child', label: 'Child' },
      { value: 'spouse', label: 'Spouse' },
      { value: 'widow', label: 'Widow/Widower' },
    ];

    return (
      <form onSubmit={handleSubmit}>
        <div className={styles.editPatientSection}>
          <div className={styles.formSectionRow}>
            <div className={styles.editLabelGroup}>
              <div className={styles[getEditClassName('firstName')]} onClick={() => this.toggleDisable('firstName')}>
                <EditIcon />
              </div>
              <Field
                component={TextInput}
                label="First Name"
                name="firstName"
                placeholder="Enter First Name"
                disabled={disabled.firstName}
              />
            </div>
            <div className={styles.editLabelGroup}>
              <div className={styles[getEditClassName('lastName')]} onClick={() => this.toggleDisable('lastName')}>
                <EditIcon />
              </div>
              <Field
                component={TextInput}
                label="Last Name"
                name="lastName"
                placeholder="Enter Last Name"
                disabled={disabled.lastName}
              />
            </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('middleName')]} onClick={() => this.toggleDisable('middleName')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="Middle Name"
                  name="middleName"
                  disabled={disabled.middleName}
                />
              </div>
            <div className={styles.editLabelGroup}>
              <div className={styles.editPlaceholder} />
            </div>
          </div>
        </div>
        <div className={styles.editPatientSection}>
          <div className={styles.formSectionRow}>
            <div className={styles.editLabelGroup}>
              <div className={styles[getEditClassName('customParticipantID')]} onClick={() => this.toggleDisable('customParticipantID')}>
                <EditIcon />
              </div>
              <Field
                component={TextInput}
                label="Patient MRN"
                name="customParticipantID"
                required={true}
                validate={[requiredValidation, notJustSpacesValidation]}
                disabled={disabled.customParticipantID}
              />
            </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('socialSecurityNumber')]} onClick={() =>  this.toggleDisable('socialSecurityNumber')}>
                    <EditIcon />
                  </div>
                  { disabled.socialSecurityNumber && idtfPatientFormData && 
                  <div>
                    <div className = {styles.ssnLabelText} >SSN</div>
                    <span className = {styles.ssnTextView}> { idtfPatientFormData.socialSecurityNumber &&  `***-**-${idtfPatientFormData.socialSecurityNumber.substring(idtfPatientFormData.socialSecurityNumber.length - 4, idtfPatientFormData.socialSecurityNumber.length)}`}</span>
                    <span className = {styles.error}>{ssnValidation(idtfPatientFormData.socialSecurityNumber)} </span>
                  </div>
                  }
                  {!disabled.socialSecurityNumber  && <Field
                    component={MaskedInput}
                    mask={ssnMask}
                    label="SSN"
                    placeholder="XXX-XX-XXXX"
                    name="socialSecurityNumber"
                    disabled={disabled.socialSecurityNumber}
                    validate={ssnValidation}
                  />}
                </div>
            <div className={styles.editLabelGroup}>
              <div className={styles[getEditClassName('sex')]} onClick={() => this.toggleDisable('sex')}>
                <EditIcon />
              </div>
              <Field
                component={ReactSelectDropdownInput}
                label="Sex"
                name="sex"
                placeholder="Select a sex"
                options={FORM_SEX_OPTIONS}
                noOptionsMessage="No Sex found"
                getOptionLabel={p => p.label}
                getOptionValue={p => p.value}
                disabled={disabled.sex}
              />
            </div>
          </div>
          <div className={styles.formSectionRow}>
            <div className={styles.editLabelGroup}>
              <div className={styles[getEditClassName('dob')]} onClick={() => this.toggleDisable('dob')}>
                <EditIcon />
              </div>
              <Field
                component={MaskedInput}
                mask={getDateOfBirthMask(me)}
                placeholder={getDateOfBirthFormat(me)}
                label="Date of Birth"
                name="dob"
                validate={dateValidation}
                disabled={disabled.dob}
              />
            </div>
            <div className={styles.editLabelGroup}>
              <div className={styles[getEditClassName('orderingPhysician')]} onClick={() => this.toggleDisable('orderingPhysician')}>
                <EditIcon />
              </div>
              <Field
                component={ReactSelectDropdownInput}
                label="Ordering Provider"
                name="orderingPhysician"
                isLoading={physicians && physicians.isFetching}
                isClearable={false}
                backspaceRemovesValue={false}
                placeholder="Unassigned"
                options={physicianOptions}
                noOptionsMessage="No provider found"
                getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
                getOptionValue={p => p.id}
                disabled={disabled.orderingPhysician}
              />
            </div>
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
                {/* Empty Space */}
              </div>
          </div>
        </div>
        <div className={styles.editPatientSection}>
          <div className={styles.editLabelGroupFull}>
            <div className={styles[getEditClassName('notes')]} onClick={() => this.toggleDisable('notes')}>
              <EditIcon />
            </div>
            <Field
              component={TextAreaInput}
              label="Notes"
              name="notes"
              placeholder="Enter Notes"
              validate={notesLenValidation}
              disabled={disabled.notes}
            />
          </div>
        </div>
          <div className={styles.editPatientSection}>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('phone')]} onClick={() => this.toggleDisable('phone')}>
                  <EditIcon />
                </div>
                <Field
                  component={MaskedInput}
                  mask={phoneNumberMask}
                  placeholder="XXX-XXX-XXXX"
                  label="Primary Phone Number"
                  name="phone"
                  validate={phoneValidation}
                  disabled={disabled.phone}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('alternatePhone')]} onClick={() => this.toggleDisable('alternatePhone')}>
                  <EditIcon />
                </div>
                <Field
                  component={MaskedInput}
                  mask={phoneNumberMask}
                  placeholder="XXX-XXX-XXXX"
                  label="Alternate Phone Number"
                  name="alternatePhone"
                  validate={phoneValidation}
                  disabled={disabled.alternatePhone}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('email')]} onClick={() => this.toggleDisable('email')}>
                  <EditIcon />
                </div>
                <Field
                  component={MaskedInput}
                  mask={emailMask}
                  placeholder="name@example.com"
                  label="Email"
                  name="email"
                  validate={[emailValidation, minLen1Validation]}
                  disabled={disabled.email}
                />
              </div>
            </div>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('emergencyContactName')]} onClick={() => this.toggleDisable('emergencyContactName')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="Emergency Contact Name"
                  name="emergencyContactName"
                  validate={notJustSpacesValidation}
                  disabled={disabled.emergencyContactName}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('emergencyContactPhone')]} onClick={() => this.toggleDisable('emergencyContactPhone')}>
                  <EditIcon />
                </div>
                <Field
                  component={MaskedInput}
                  mask={phoneNumberMask}
                  placeholder="XXX-XXX-XXXX"
                  label="Emergency Contact Number"
                  name="emergencyContactPhone"
                  validate={phoneValidation}
                  disabled={disabled.emergencyContactPhone}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
                {/* Empty Space */}
              </div>
            </div>
          </div>
          <div className={styles.editPatientSection}>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('patientAddressLine1')]} onClick={() => this.toggleDisable('patientAddressLine1')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="Patient Address Line 1"
                  name="patientAddressLine1"
                  validate={notJustSpacesValidation}
                  disabled={disabled.patientAddressLine1}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('patientAddressLine2')]} onClick={() => this.toggleDisable('patientAddressLine2')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="Patient Address Line 2"
                  name="patientAddressLine2"
                  validate={notJustSpacesValidation}
                  disabled={disabled.patientAddressLine2}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('patientCity')]} onClick={() => this.toggleDisable('patientCity')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="patient City"
                  name="patientCity"
                  validate={notJustSpacesValidation}
                  disabled={disabled.patientCity}
                />
              </div>
            </div>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('patientState')]} onClick={() => this.toggleDisable('patientState')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="patient State"
                  name="patientState"
                  placeholder="Select a state"
                  options={US_STATES}
                  noOptionsMessage="No State found"
                  getOptionLabel={p => `${p.name} - ${p.code}`}
                  getOptionValue={p => p.code}
                  disabled={disabled.patientState}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('patientZip')]} onClick={() => this.toggleDisable('patientZip')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="patient ZIP"
                  name="patientZip"
                  validate={[validateZipCode, notJustSpacesValidation]}
                  disabled={disabled.patientZip}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
              </div>
            </div>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('shippingAddressLine1')]} onClick={() => this.toggleDisable('shippingAddressLine1')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="shipping Address Line 1"
                  name="shippingAddressLine1"
                  validate={notJustSpacesValidation}
                  disabled={disabled.shippingAddressLine1}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('shippingAddressLine2')]} onClick={() => this.toggleDisable('shippingAddressLine2')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="shipping Address Line 2"
                  name="shippingAddressLine2"
                  validate={notJustSpacesValidation}
                  disabled={disabled.shippingAddressLine2}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('shippingCity')]} onClick={() => this.toggleDisable('shippingCity')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="shipping City"
                  name="shippingCity"
                  validate={notJustSpacesValidation}
                  disabled={disabled.shippingCity}
                />
              </div>
            </div>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('shippingState')]} onClick={() => this.toggleDisable('shippingState')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="shipping State"
                  name="shippingState"
                  placeholder="Select a state"
                  options={US_STATES}
                  noOptionsMessage="No State found"
                  getOptionLabel={p => `${p.name} - ${p.code}`}
                  getOptionValue={p => p.code}
                  disabled={disabled.shippingState}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('shippingZip')]} onClick={() => this.toggleDisable('shippingZip')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  label="shipping ZIP"
                  name="shippingZip"
                  validate={[validateZipCode, notJustSpacesValidation]}
                  disabled={disabled.shippingZip}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
              </div>
            </div>
          </div>
          <div>
            <div className={styles.formTop}>
              <h2 className={styles.formTitle}>Insurance</h2>
            </div>
            <div className={styles.editPatientSection}>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryInsuranceType')]} onClick={() => this.toggleDisable('primaryInsuranceType')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={ReactSelectDropdownInput}
                    label="Primary Insurance Type"
                    name="primaryInsuranceType"
                    placeholder="Select Insurance Type"
                    options={PRIMARY_INSURANCE_TYPE_OPTIONS}
                    noOptionsMessage="No Insurance Type found"
                    getOptionLabel={p => p.label}
                    getOptionValue={p => p.value}
                    disabled={disabled.primaryInsuranceType}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryInsuranceCompanyName')]} onClick={() => this.toggleDisable('primaryInsuranceCompanyName')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Insurance Company Name"
                    name="primaryInsuranceCompanyName"
                    validate={notJustSpacesValidation}
                    disabled={disabled.primaryInsuranceCompanyName}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryInsuranceGroup')]} onClick={() => this.toggleDisable('primaryInsuranceGroup')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Insurance Group"
                    name="primaryInsuranceGroup"
                    validate={notJustSpacesValidation}
                    disabled={disabled.primaryInsuranceGroup}
                  />
                </div>
              </div>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryInsuranceAuthorizationNumber')]} onClick={() => this.toggleDisable('primaryInsuranceAuthorizationNumber')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Insurance Authorization Number"
                    name="primaryInsuranceAuthorizationNumber"
                    validate={notJustSpacesValidation}
                    disabled={disabled.primaryInsuranceAuthorizationNumber}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryPolicyHolderName')]} onClick={() => this.toggleDisable('primaryPolicyHolderName')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Policy Holder Name"
                    name="primaryPolicyHolderName"
                    validate={notJustSpacesValidation}
                    disabled={disabled.primaryPolicyHolderName}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryPolicyHolderRelationship')]} onClick={() => this.toggleDisable('primaryPolicyHolderRelationship')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={ReactSelectDropdownInput}
                    label="Policy Holder Relationship"
                    name="primaryPolicyHolderRelationship"
                    placeholder="Select Relationship"
                    options={POLICY_HOLDER_RELATIONSHIP_OPTIONS}
                    noOptionsMessage="No Relationship found"
                    getOptionLabel={p => p.label}
                    getOptionValue={p => p.value}
                    disabled={disabled.primaryPolicyHolderRelationship}
                  />
                </div>
              </div>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primarySubscriberId')]} onClick={() => this.toggleDisable('primarySubscriberId')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Subscriber/Policy/Member ID"
                    name="primarySubscriberId"
                    validate={notJustSpacesValidation}
                    disabled={disabled.primarySubscriberId}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('primaryMedicareId')]} onClick={() => this.toggleDisable('primaryMedicareId')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Medicare Id Number"
                    name="primaryMedicareId"
                    validate={notJustSpacesValidation}
                    disabled={disabled.primaryMedicareId}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  {/* Empty Field */}
                </div>
              </div>
            </div>
            <div className={styles.editPatientSection}>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryInsuranceType')]} onClick={() => this.toggleDisable('secondaryInsuranceType')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={ReactSelectDropdownInput}
                    label="Secondary Insurance Type"
                    name="secondaryInsuranceType"
                    placeholder="Select Insurance Type"
                    options={SECONDARY_INSURANCE_TYPE_OPTIONS}
                    noOptionsMessage="No Insurance Type found"
                    getOptionLabel={p => p.label}
                    getOptionValue={p => p.value}
                    disabled={disabled.secondaryInsuranceType}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryInsuranceCompanyName')]} onClick={() => this.toggleDisable('secondaryInsuranceCompanyName')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Insurance Company Name"
                    name="secondaryInsuranceCompanyName"
                    validate={notJustSpacesValidation}
                    disabled={disabled.secondaryInsuranceCompanyName}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryInsuranceGroup')]} onClick={() => this.toggleDisable('secondaryInsuranceGroup')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Insurance Group"
                    name="secondaryInsuranceGroup"
                    validate={notJustSpacesValidation}
                    disabled={disabled.secondaryInsuranceGroup}
                  />
                </div>
              </div>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryInsuranceAuthorizationNumber')]} onClick={() => this.toggleDisable('secondaryInsuranceAuthorizationNumber')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Insurance Authorization Number"
                    name="secondaryInsuranceAuthorizationNumber"
                    validate={notJustSpacesValidation}
                    disabled={disabled.secondaryInsuranceAuthorizationNumber}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryPolicyHolderName')]} onClick={() => this.toggleDisable('secondaryPolicyHolderName')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Policy Holder Name"
                    name="secondaryPolicyHolderName"
                    validate={notJustSpacesValidation}
                    disabled={disabled.secondaryPolicyHolderName}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryPolicyHolderRelationship')]} onClick={() => this.toggleDisable('secondaryPolicyHolderRelationship')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={ReactSelectDropdownInput}
                    label="Policy Holder Relationship"
                    name="secondaryPolicyHolderRelationship"
                    placeholder="Select Relationship"
                    options={POLICY_HOLDER_RELATIONSHIP_OPTIONS}
                    noOptionsMessage="No Relationship found"
                    getOptionLabel={p => p.label}
                    getOptionValue={p => p.value}
                    disabled={disabled.secondaryPolicyHolderRelationship}
                  />
                </div>
              </div>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondarySubscriberId')]} onClick={() => this.toggleDisable('secondarySubscriberId')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Subscriber/Policy/Member ID"
                    name="secondarySubscriberId"
                    validate={notJustSpacesValidation}
                    disabled={disabled.secondarySubscriberId}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <div className={styles[getEditClassName('secondaryMedicareId')]} onClick={() => this.toggleDisable('secondaryMedicareId')}>
                    <EditIcon />
                  </div>
                  <Field
                    component={TextInput}
                    label="Medicare Id Number"
                    name="secondaryMedicareId"
                    validate={notJustSpacesValidation}
                    disabled={disabled.secondaryMedicareId}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  {/* Empty Field */}
                </div>
              </div>
            </div>
          </div>
        <div className={styles.submitWrapper}>
          <div className={styles.buttonWrapper}>
            {submitting || isSubmitting ?
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
              :
              <button
                type="submit"
                disabled={invalid || pristine || ssnValidation(idtfPatientFormData.socialSecurityNumber)}
                className={styles.submit}
                data-action="button-edit-profile"
                data-label="save"
              >
                <SaveIcon />
                Save
              </button>
            }
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'editPatientForm',
  enableReinitialize: true,
})(EditPatientForm)


// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/EditIDTFPatientForm.jsx